var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('v-index',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("实训")]),_c('el-breadcrumb-item',[_c('a',{staticStyle:{"color":"#000000"}},[_vm._v("基地管理")])])],1),_c('v-weburl-iframe',{attrs:{"url":"train/base/index"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }